module.exports = __webpack_public_path__ + "static/media/jewellery.b399a6aa.JPG";